'use client';

import { useState, useCallback } from 'react';
import { OverviewStats } from '@/components/trends/overview-stats';
import { TrendFilters } from '@/components/trends/trend-filters';
import { TrendGrid } from '@/components/trends/trend-grid';
import type { TrendFilters as TrendFiltersType } from '@/hooks/use-trends';

export default function TrendsPage() {
  const [filters, setFilters] = useState<TrendFiltersType>({
    sort_by: 'created_at',
    order: 'desc',
  });

  const handleFiltersChange = useCallback((newFilters: TrendFiltersType) => {
    setFilters(newFilters);
  }, []);

  return (
    <div className="space-y-6">
      <OverviewStats />
      <TrendFilters onFiltersChange={handleFiltersChange} />
      <TrendGrid filters={filters} />
    </div>
  );
}
